import { render, staticRenderFns } from "./DocumentAnnotations.vue?vue&type=template&id=a50a3ab6&scoped=true&"
import script from "./DocumentAnnotations.vue?vue&type=script&lang=js&"
export * from "./DocumentAnnotations.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=a50a3ab6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50a3ab6",
  null
  
)

export default component.exports